import classNames from "classnames";

interface IAvisErrorMessageProps {
  value: string | undefined;
  className?: string;
}
export function AvisErrorMessage(props: Readonly<IAvisErrorMessageProps>) {
  const { value, className } = props;
  const classNameLocal = classNames("row", "dots-error-message", className);
  return <div className={classNameLocal}>{value}</div>;
}
